import React, { useState, useEffect } from 'react';
import { Table, Card, Button } from "reactstrap";
import { Link } from "react-router-dom";
import api, { FILE_BASE_URL } from '../../utils/api';

const LatestInstitutions = () => {
    const [institutions, setInstitutions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [failedImages, setFailedImages] = useState(new Set());

    const formatDate = (dateString) => {
        if (!dateString) return 'غير محدد';
        
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    // دالة لإنشاء الدائرة الملونة
    const getAvatarCircle = (name) => {
        const firstLetter = name ? name.charAt(0).toUpperCase() : 'م';
        
        return (
            <div 
                className="avatar-xs me-2 rounded-circle d-inline-flex align-items-center justify-content-center"
                style={{
                    backgroundColor: '#556ee6', // أزرق للمؤسسات
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    width: '30px',
                    height: '30px'
                }}
            >
                {firstLetter}
            </div>
        );
    };

    // دالة للحصول على الأفاتار (صورة أو دائرة)
    const getProfileAvatar = (institution, index) => {
        const imageKey = `institution-${institution.id}-${index}`;
        
        // إذا فشلت الصورة مسبقاً، اعرض الدائرة مباشرة
        if (!institution.logo || failedImages.has(imageKey)) {
            return getAvatarCircle(institution.title);
        }

        // تحديد مسار الصورة الصحيح
        let imageSrc = '';
        if (institution.logo.startsWith('http')) {
            imageSrc = institution.logo;
        } else {
imageSrc = `${FILE_BASE_URL}/uploads/images/${institution.logo}`;   
    }

        return (
            <img 
                src={imageSrc} 
                alt="institution" 
                className="avatar-xs me-2 rounded-circle"
                onError={() => {
                    // أضف الصورة لقائمة الفاشلة
                    setFailedImages(prev => new Set([...prev, imageKey]));
                }}
            />
        );
    };

    const fetchInstitutions = async () => {
      try {
           setLoading(true);
           const response = await api.get("/institutions");
           const data = response.data.data || response.data || [];
            
            // أخذ آخر 6 مؤسسات
            setInstitutions(data.slice(0, 6));
        } catch (error) {
            console.error("خطأ في جلب المؤسسات:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInstitutions();
    }, []);

    if (loading) {
        return (
            <Card>
                <div className="card-body">
                    <h4 className="card-title mb-4">آخر المؤسسات</h4>
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">جاري التحميل...</span>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }

    return (
        <Card>
            <div className="card-body">
                <h4 className="card-title mb-4">آخر المؤسسات</h4>

                <div className="table-responsive">
                    <Table className="align-middle table-centered table-vertical table-nowrap mb-1">
                        <tbody>
                            {institutions.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center py-4 text-muted">
                                        لا توجد بيانات لعرضها
                                    </td>
                                </tr>
                            ) : (
                                institutions.map((institution, key) => (
                                    <tr key={key}>
                                        <td>
                                            {getProfileAvatar(institution, key)}
                                            {institution.title || 'غير محدد'}
                                        </td>
                                        <td>
                                            {formatDate(institution.created_at)}
                                        </td>
                                        <td>
                                            <Link to={`/dashboard/institutions/edit/${institution.id}`}>
                                                <Button 
                                                    color="secondary" 
                                                    size="sm" 
                                                    className="waves-effect waves-light"
                                                >
                                                    تعديل
                                                </Button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Card>
    );
};

export default LatestInstitutions;